<!-- TelaExtraiDadosUsuario.svelte -->
<script>
    import InsereDadosBasico from "../../Componentes/InsercaoDados/InserirDadosBasico.svelte";
    import  {ItemInserir, Tipo, generateCreateTableSQL}  from "../../Classes/ItemInserir.js";
    import AlteraDadosBasico from "../../Componentes/AlteracaoDados/AlteraDadosBasico.svelte";
    
      
    export let id;
    //$: id1 =$params.id ;
    //const { id } = params.state;
    const apiInsercao = "inserir.php";
    const apiConsultaEdicao = "consultas.php";
    const apiEdicao = "editar.php";
    const query_code_inserir= "inserir_usuario";
    const query_code_editar= "editar";
    const query_code_apagar="apagar";
    const query_code_carregar_edicao="carrega_dados";
    const navegar_para_pos_edicao="/usuarios";
    const tabela="usuarios";
    
    const itens = [
      new ItemInserir({rotulo:"Nome", nomeColuna:"nome_usuario", tamanho:30, tipo:Tipo.TEXTO, obrigatorio:true}),
      new ItemInserir({rotulo:"Email", nomeColuna:"email", tamanho:30, tipo:Tipo.EMAIL,  obrigatorio:true , readonly:true}),
      new ItemInserir({rotulo:"Senha", nomeColuna:"senha", tamanho:30, tipo:Tipo.PASSWORD}),
     
         new ItemInserir({
      rotulo: "Gênero",
      nomeColuna: "genero",
      tamanho: 30,
      tipo: Tipo.SELECAO,
      config_drop_down: {
        api: "consultas.php",
        parametros: { query_code: "teste" },
        nome_coluna_opcoes: "email",
        nome_coluna_saida: "email",
        filtravel: true,
        itens: "",
      },
    }),

     
    ]; 
  //console.log(generateCreateTableSQL("tabela",itens));
    //só precisa configurar acima disto
  </script>
  <style>
  .espacar{

    margin-bottom: 3em;
  }
  
  
  </style> 
  
  
   <div class="espacar">

  {#if id}
  <AlteraDadosBasico {id} {apiEdicao} {apiConsultaEdicao} {itens} 
  {query_code_carregar_edicao}
  {query_code_editar}
  {query_code_apagar}
  {tabela}
  navegar_para =  {navegar_para_pos_edicao}
  />


  {:else}
  <InsereDadosBasico api={apiInsercao} {itens} {query_code_inserir} {tabela}/>

  {/if}
    
  </div>
  
  
  
  